import React from "react";
import { FaMapMarkerAlt, FaPhoneAlt, FaFacebook, FaInstagram, FaYoutube, FaWhatsapp } from "react-icons/fa";
import '../styles/SocialMediaLinks.css';

const directPhoneNumber = '+919619419697';
const cleanPhoneForTel = (phone = '') => phone.replace(/[^\d+]/g, '');
const phoneLink = `tel:${cleanPhoneForTel(directPhoneNumber)}`;

const contactActions = [
    {
      href: 'https://share.google/Kkjf7UEwbFLJixSwC',
      label: 'Google Business',
      icon: FaMapMarkerAlt,
      external: true
    },
    {
      href: phoneLink,
      label: 'Call',
      icon: FaPhoneAlt,
      external: false
    },
    {
      href: 'https://www.facebook.com/getfitwithdaniella/',
      label: 'Facebook',
      icon: FaFacebook,
      external: true
    },
    {
      href: 'https://wa.me/917756812142',
      label: 'WhatsApp',
      icon: FaWhatsapp,
      external: true
    },
    {
      href: 'https://www.instagram.com/getfitwith_daniella/',
      label: 'Instagram',
      icon: FaInstagram,
      external: true
    },
    {
      href: 'https://youtube.com/@getfitwithdaniella6876?si=dH9dkjxM2nTtbgTg',
      label: 'YouTube',
      icon: FaYoutube,
      external: true
    }
  ];
const socialLinks = [
  {
    name: "Facebook",
    icon: <FaFacebook />,
    url: "https://www.facebook.com/share/1YbvjyXCKM/?mibextid=wwXIfr"
  },
  {
    name: "whatsApp",
    icon: <FaWhatsapp />,
    url: "https://wa.me/917756812142"
  },
  {
    name: "Instagram",
    icon: <FaInstagram />,
    url: "https://www.instagram.com/getfitwith_daniella?igsh=MXhvOTlxZGd4YjBmNg%3D%3D&utm_source=qr"
  },
  {
    name: "YouTube",
    icon: <FaYoutube />,
    url: "https://youtube.com/@getfitwithdaniella6876?si=dH9dkjxM2nTtbgTg"
  }
];
const SocialMediaLinks = ({ hasDescription = false }) =>{
  if(hasDescription){
    return (<div className="contact-quick-links">
                {contactActions.map((action) => {
                  const Icon = action.icon;
                  return (
                    <a key={action.label} href={action.href} className="quick-link" aria-label={action.label}
                      target={action.external ? '_blank' : undefined} rel={action.external ? 'noopener noreferrer' : undefined}>
                      <Icon size={18} />
                      <span>{action.label}</span>
                    </a>
                  );
                })}
             </div>)
  }else{
    return (<div className="social-media-links">
                <div>Follow Us</div>
                <div className="social-icons">
                    {socialLinks.map((item) => 
                        (<a key={item.name} href={item.url} target="_blank"
                            rel="noopener noreferrer" aria-label="{item.name}">{item.icon}</a>)
                    )}
                </div>
             </div>);   
  }
}

export {SocialMediaLinks};